export type DbEnv =
  | "develop_local_dump"
  | "stage_local_dump"
  | "prod_local_dump"
  | "local"
  | "local_test"
  | "docker_test"
  | "sandbox1"
  | "sandbox2"
  | "sandbox3"
  | "sandbox4"
  | "sandbox5"
  | "sandbox6"
  | "sandbox7"
  | "sandbox8"
  | "sandbox9"
  | "sandbox10"
  | "sandbox11"
  | "sandbox12"
  | "sandbox13"
  | "sandbox14"
  | "sandbox15"
  | "sandbox16"
  | "demo1"
  | "pr"
  | "develop"
  | "qa"
  | "stage"
  | "prod";

export const remoteDbs: DbEnv[] = [
  "sandbox1",
  "sandbox2",
  "sandbox3",
  "sandbox4",
  "sandbox5",
  "sandbox6",
  "sandbox7",
  "sandbox8",
  "sandbox9",
  "sandbox10",
  "sandbox11",
  "sandbox12",
  "sandbox13",
  "sandbox14",
  "sandbox15",
  "sandbox16",
  "demo1",
  "pr",
  "develop",
  "qa",
  "stage",
  "prod",
] as const;

export const sandboxDbs: DbEnv[] = remoteDbs.filter((db) => db.startsWith("sandbox"));
